const development = {
  env: 'development',
  backendUrl: 'https://ctt-uat-e-customer-web.de-c1.cloudhub.io/customer-web',
  hasDebug: true,
  hasMocks: false,
  isTest: false,
}

export default development
